module.exports = __webpack_public_path__ + "img/graph-selected.20610f44.png";